/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItemsLanding_similarItems$ref = any;
export type PdpRespContainer_similarLandingItems$ref = any;
export type PdpRespContainer_similarLandingItems = {
    readonly " $fragmentRefs": PdpRespSimilarItemsLanding_similarItems$ref;
    readonly " $refType": PdpRespContainer_similarLandingItems$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_similarLandingItems",
  "type": "moreLikeThisConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_similarItems",
      "args": null
    }
  ]
};
(node as any).hash = '41b67f509beac092dead980409e13c01';
export default node;
